var _circle, _line, _line2, _line3, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.87,
    cy: 29.08,
    r: 11.14
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27.39,
    y1: 57.28,
    x2: 27.39,
    y2: 40.72
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17.81,
    y1: 49.08,
    x2: 36.96,
    y2: 49.08
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 8.5,
    x2: 34.99,
    y2: 21.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "36.23 8.22 48.27 8.22 48.27 20.26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.2a700a254d76878a505e787fafbb1332.svg";
export { ForwardRef as ReactComponent };